// src/components/Nav.jsx
import React, { useState } from 'react';
import '../styles/Nav.css';

const Nav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  return (
    <nav class="navbar">
      <input type="checkbox" id="nav-toggle" class="nav-toggle" />

      <div class="nav-logo">
        <a href="/">FVS Catering</a>
      </div>

      <label for="nav-toggle" class="nav-toggle-label">
        <span class="open-icon">☰</span>
        <span class="close-icon">✕</span>
      </label>

      <ul class="nav-menu nav-menu-desktop">
        <li><a href="#about">Nosotros</a></li>
        <li><a href="#services">Propuestas</a></li>
        <li><a href="#gallery-accordion">Galeria</a></li>
        <li><a href="#testimonios">Testimonios</a></li>
        <li><a href="#contacto">Contacto</a></li>
      </ul>

      <ul class="nav-menu nav-menu-mobile">
        <li><a href="#about">Empresa</a></li>
        <li><a href="#services">Servicios</a></li>
        <li><a href="#gallery-accordion">Galeria</a></li>
        <li><a href="#testimonios">Testimonios</a></li>
        <li><a href="#contacto">Contacto</a></li>
      </ul>
    </nav>

  );
};

export default Nav;
